const fr = {
  "Home.taskName": "Nom de la tâche",
  "Home.addNewTask": "Ajouter",
  "Home.noTask": "Vous n'avez aucune tâche. Ajoutez-en un nouveau!",
  "Nav.deleteAllTask": "Supprimer toutes les tâches",
};

export default fr;
